export default "__VITE_ASSET__CgYYlOiM__"